import React, { Component } from 'react';
import * as Actions from '../../store/actions/profile';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../models/action/core';
import VirtualClass from './virtualClass';
import Exams from './exams';
import Assignments from './assignments';
import Activity from './activityStats';
import Grade from './grade';
import Forums from './forums';
import Messages from './messages';
import Announcement from './announcement';
import { IHomePageBoxProps } from '../../models/components/hompage-box';
import { IPreference } from '../../models/action/profile';
import { HomeIndexBoxType } from '../../models/enums/HomeIndexBoxType';
import { Log } from 'ng2-logger';
import moment from 'moment';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import BaseModal from '../../modal/base-modal/main';
import LoginAnnouncementModal from '../../modal/in-modal/login-announcement/main';
import ChatPanel from '../../pages/messages/chatPanel';
import { UserType } from '../../models/enums/userType';
import * as VirtualClassActions from '../../store/actions/virtualClass';
import * as ExamActions from '../../store/actions/exam';
import * as AssignmentActions from '../../store/actions/assignment';
import * as MessagePageActions from '../../store/actions/messages';
import * as ForumPageActions from '../../store/actions/forum';
import * as AnnouncementPageActions from '../../store/actions/announcementPage';
import Survey from './survey';
import * as SurveyPageActions from '../../store/actions/survey';
import { ModuleItems } from '../../models/enums/moduleItems';

const _common = new Common();
const T = Translator.create();
const _logger = Log.create('Homepage Box');

const ComponentNames = ['VirtualClass', 'Activities', 'Notes', 'Messages', 'Discussions', 'Announcement', 'Exams', 'Assignments', 'Survey'];

export class CSubmain extends Component<IHomePageBoxProps> {
    public state = {
        boxVisual: '',
        boxCount: '',
        components: '',
        dateFormat: 'DD.MM.YYYY',
        isAnnouncementModalOpen: false,
        isSurveyModalOpen: false,
        modalHeaderData: '',
        isMessageModelOpen: false,
        userPermissions: [],
        loaded: false
    };

    constructor(props: IHomePageBoxProps) {
        super(props);
    }

    componentWillMount(): void {
        this.props.dispatch(VirtualClassActions.getMyVirtualClassGetAction({ Take: 10, Skip: 0, lastActivityId: "" }, 'getHomeBoxVirtualClass', 'get'));

        this.props.dispatch(ExamActions.getMyExamsGetAction({ Take: 10, Skip: 0, lastActivityId: "" }, 'getHomeBoxExam', 'get'));

        this.props.dispatch(AssignmentActions.getMyAssignmentsGetAction({ Take: 10, Skip: 0, lastActivityId: "" }, 'getHomeBoxAssignment', 'get'));

        if (this.props.messages) {
            this.props.dispatch(MessagePageActions.getHomeBoxGetAction({ Take: 10, Skip: 0, IsGroup: false, lastMessageId: (this.props.messages && this.props.messages.conversations.length > 0) ? this.props.messages.conversations[0].originMessageId : '' }, true, 'getHomeBoxMessages', 'get'));
        } else {
            this.props.dispatch(MessagePageActions.getHomeBoxGetAction({ Take: 10, Skip: 0, IsGroup: false, lastMessageId: '' }, true, 'getHomeBoxMessages', 'get'));
        }

        this.props.dispatch(ForumPageActions.getHomePageConversationGetAction({ Take: 10, Skip: 0, Type: 0, Order: 'LastMessageDate_desc' }, 'getHomeBoxForums', 'get'));

        if (this.props.announcements) {
            this.props.dispatch(AnnouncementPageActions.getAnnouncementsAction('4', 'getHomeBoxAnnouncement', 'get', 15, 0, undefined, undefined, true, undefined, this.props.announcements.length > 0 ? this.props.announcements[0].lastAnnouncementId : "", true));
        } else {
            this.props.dispatch(AnnouncementPageActions.getAnnouncementsAction('4', 'getHomeBoxAnnouncement', 'get', 12, 0, undefined, undefined, true));
        }

        this.props.dispatch(SurveyPageActions.getSurveysAction('4', 'getHomeBoxSurvey', 'get', 15, 0, undefined, undefined, true));

    }

    public diffDate = (date: any, serverTime: any) => {
        const dateMoment = moment(date);
        const nowMoment = moment(serverTime);

        if (nowMoment > dateMoment) {
            const diff = moment.duration(nowMoment.diff(dateMoment));
            if (diff.days() > 15) return dateMoment.format(this.state.dateFormat);

            if (diff.days()) return T.t('r_gen_days_before').replace('{0}', diff.days());
            if (diff.minutes()) return T.t('r_gen_minutes_before').replace('{0}', diff.minutes());
            if (diff.seconds()) return T.t('r_gen_seconds_before').replace('{0}', diff.seconds());
        }
    };

    public diffActivityDate = (startDate: any, endDate: any, serverTime: any, activityType: string) => {
        const startMoment = moment(startDate);
        const endMoment = moment(endDate);
        const nowMoment = moment(serverTime);
        const diffEndStart = moment.duration(endMoment.diff(startMoment));
        const diffStartNow = moment.duration(startMoment.diff(nowMoment));
        const diffEndNow = moment.duration(endMoment.diff(nowMoment));

        if (nowMoment < endMoment) {
            if (
                diffStartNow.minutes() < 0 || diffStartNow.seconds() < 0
            ) {
                return (
                    <>
                        <div className="w-100 lead-bar d-inline-block">
                            <div
                                style={{
                                    width:
                                        Math.round(
                                            (100 * (nowMoment.valueOf() - startMoment.valueOf())) / (endMoment.valueOf() - startMoment.valueOf())
                                        ) + '%'
                                }}
                                className="lead-bar-width"
                            />
                        </div>
                        {
                            activityType !== "assignment" && activityType !== "exam" &&
                            <div className="ml-2 lead-bar-text d-inline-block">
                                {startMoment.format(activityType === "virtualClass" ? 'HH:mm' : _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 2))} / {endMoment.format(activityType === "virtualClass" ? 'HH:mm' : _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 2))}
                            </div>
                        }

                    </>
                );
            } else if (diffStartNow.days() > 5) {
                if (activityType !== "virtualClass") {
                    return (
                        <i>
                            {startMoment.format(_common.GetDateFormatFromPrefrences(this.props.userPreferences!, 2))} / {endMoment.format(_common.GetDateFormatFromPrefrences(this.props.userPreferences!, 2))}
                        </i>
                    )
                }
                return (
                    <i>
                        {startMoment.format(_common.GetDateFormatFromPrefrences(this.props.userPreferences!, 2))} / {endMoment.format('HH:mm')}
                    </i>
                );
            } else {
                if (diffStartNow.days()) return <i style={{ color: 'green' }}>{T.t('r_gen_days_after').replace('{0}', diffStartNow.days())}</i>;
                if (diffStartNow.hours()) return <i style={{ color: 'green' }}>{T.t('r_gen_hours_after').replace('{0}', diffStartNow.hours())}</i>;
                if (diffStartNow.minutes()) return <i style={{ color: 'green' }}>{T.t('r_gen_minutes_after').replace('{0}', diffStartNow.minutes())}</i>;
                if (diffStartNow.seconds()) return <i style={{ color: 'green' }}>{T.t('r_gen_seconds_after').replace('{0}', diffStartNow.seconds())}</i>;
            }
        }
    };

    triggerAnnouncementModal = () => {
        this.setState({
            isAnnouncementModalOpen: !this.state.isAnnouncementModalOpen,
        });
    };

    triggerSurveyModal = () => {
        this.setState({
            isSurveyModalOpen: !this.state.isSurveyModalOpen,
        });
    }

    triggerMessageModal = () => {
        this.setState({
            isMessageModelOpen: !this.state.isMessageModelOpen,
        });
    };

    public headerState = (value: string) => {
        if (value) {
            this.setState({ modalHeaderData: value });
        }
    }

    /* tslint:disable-next-line */

    public getComponentArray(id: number, loaded: boolean) {
        let componentArray = [
            <VirtualClass diffVirtualClassDate={this.diffActivityDate} key="virtualclass_box" />,
            <Activity key="activity_box" loaded={loaded} />,
            <Grade diffDate={this.diffDate} loaded={loaded} key="grade_box" />,
            <Messages triggerMessageModal={this.triggerMessageModal} key="message_box" />,
            <Forums diffDate={this.diffDate} key="forum_box" />,
            <Announcement triggerAnnouncementModal={this.triggerAnnouncementModal} diffDate={this.diffDate} key="announcement_box" />,
            <Exams diffExamDate={this.diffActivityDate} key="exams_box" />,
            <Assignments diffAssignmentDate={this.diffActivityDate} key="assignments_box" />,
            <Survey triggerSurveyModal={this.triggerSurveyModal} key="survey_box" />
        ]

        if (!this.state.loaded && id == 2) {
            this.setState({ loaded: true })
        }
        return componentArray[id];
    }

    public _renderSubComponents(columnCount: number) {
        const html = [];
        let htmlComponents = [];

        const showComponentsIndex = [];
        let splitComponents;

        splitComponents = this.state.components.split(',');

        splitComponents.forEach((component: any, index: any) => {
            switch (parseInt(component, 10)) {
                case HomeIndexBoxType.Activity:
                    splitComponents[index] = 'Activities';
                    break;
                case HomeIndexBoxType.Announcement:
                    if (this.props.moduleItems?.includes(ModuleItems.Announcement)) {
                        splitComponents[index] = 'Announcement';
                    }
                    break;
                case HomeIndexBoxType.Survey:
                    if (this.props.moduleItems?.includes(ModuleItems.Survey)) {
                        splitComponents[index] = 'Survey';
                    }
                    break;
                case HomeIndexBoxType.Forum:
                    if (this.props.moduleItems?.includes(ModuleItems.Forum)) {
                        splitComponents[index] = 'Discussions';
                    }
                    break;
                case HomeIndexBoxType.Grade:
                    splitComponents[index] = 'Notes';
                    break;
                case HomeIndexBoxType.Message:
                    if (this.props.moduleItems?.includes(ModuleItems.Messaging)) {
                        splitComponents[index] = 'Messages';
                    }
                    break;
                case HomeIndexBoxType.VirtualClass:
                    if (this.props.moduleItems?.includes(ModuleItems.Activities_VirtualClass)) {
                        splitComponents[index] = 'VirtualClass';
                    }
                    break;
                case HomeIndexBoxType.Exam:
                    if (this.props.moduleItems?.includes(ModuleItems.Activities_Exam)) {
                        splitComponents[index] = 'Exams';
                    }
                    break;
                case HomeIndexBoxType.Assignment:
                    if (this.props.moduleItems?.includes(ModuleItems.Activities_Assignment)) {
                        splitComponents[index] = 'Assignments';
                    }
                    break;
                default:
                    break;
            }
        });

        // for (const component of splitComponents) {
        //     if (ComponentNames.indexOf(component) > -1) {
        //         showComponentsIndex.push(ComponentNames.indexOf(component));
        //     }
        // }

        // for (let componentIndex = 0; componentIndex < showComponentsIndex.length; componentIndex++) {
        //     if (componentIndex % columnCount === 0 && htmlComponents.length > 0) {
        //         html.push(<div key={Math.random() * 10000} className="row">{htmlComponents}</div>);
        //         htmlComponents = [];
        //     }

        //     htmlComponents.push(
        //         <div key={Math.random() * 10000} className={columnCount === 2 ? 'col-md-12' : 'col-md-4'}>
        //             {this.getComponentArray(showComponentsIndex[componentIndex], this.state.loaded)}
        //         </div>
        //     );
        // }
        // if (htmlComponents.length > 0) {
        //     html.push(<div key={Math.random() * 10000} className="row b" >{htmlComponents}</div>);
        // }

        // return html;
        // Find valid component indexes based on ComponentNames
        for (const component of splitComponents) {
            if (ComponentNames.indexOf(component) > -1) {
                showComponentsIndex.push(ComponentNames.indexOf(component));
            }
        }

        // Return the JSX directly without wrapping divs
        return showComponentsIndex.map((componentIndex) => (
            <div key={componentIndex} className={columnCount === 2 ? 'col-md-6 col-12' : 'col-md-4 col-12'}>
                {this.getComponentArray(componentIndex, this.state.loaded)}
            </div>
        ));
    }

    callback = () => {
        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount') as IPreference).value
                });
            } else {
                this.setState({ boxCount: '3' });
            }

            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxallowed')) {
                this.setState({
                    components: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxallowed') as IPreference).value
                });
            } else {
                this.setState({ components: '' });
            }

            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxvisual')) {
                this.setState({
                    boxVisual: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxvisual') as IPreference).value
                });
            } else {
                this.setState({ boxVisual: 'true' });
            }

            if (this.props.userPreferences!.find(pref => pref.name === 'application.dateformat')) {
                this.setState({
                    dateFormat: (this.props.userPreferences!.find(pref => pref.name === 'application.dateformat') as IPreference).value
                });
            }
        } else if (this.props.userType === UserType.Teacher) {
            this.setState({
                boxCount: '3',
                components: '5,3,4,0',
                boxVisual: 'true'
            });
        } else if (this.props.userType === UserType.Student) {
            this.setState({
                boxCount: '3',
                components: '8,7,6,5,3,1,2,4,0',
                boxVisual: 'true'
            });
        }
    }

    componentDidMount() {
        this.props.dispatch(Actions.getPreferencesAction('', undefined, this.callback));
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps !== this.props) {
            this.callback();
        }
    }

    public render() {
        if (this.props.isSimulate) {
            return;
        }
        var retuntAnnouncementHtml =
            <BaseModal
                minWidth={1100}
                modalIsOpen={this.state.isAnnouncementModalOpen}
                onClose={this.triggerAnnouncementModal}
                headerState={this.state.modalHeaderData}
                headerIcon={'clock'}
                backdrop={this.props.selectedAnnouncement && this.props.selectedAnnouncement.showReadConfirmation && this.props.selectedAnnouncement.showReadConfirmation != undefined ? 'static' : ''}
                showHeader={true}
            >
                <LoginAnnouncementModal headerState={this.headerState} onClickChangeAnnouncement={this.triggerAnnouncementModal} leftAnnouncementCount={0} />
            </BaseModal>;

        return this.state.boxVisual === 'true' ? (
            <>
                {this.state.isAnnouncementModalOpen ? retuntAnnouncementHtml : null}

                {this.state.isMessageModelOpen ? (
                    <ChatPanel onClose={this.triggerMessageModal} isModalOpen={this.state.isMessageModelOpen} isSubmain={true} />
                ) : null}

                {this.state.boxCount === '2' ? this._renderSubComponents(2) : this._renderSubComponents(3)}
                {/* {this._renderSubComponents(2)} */}

            </>
        ) : (
            ''
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxProps): IHomePageBoxProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IHomePageBoxProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        userPermissions: state.login.identitiy.loginPermission,
        announcements: state.announcement.homePageAnnouncements,
        activityCard: state.coursePage.activityCard,
        selectedSurvey: state.survey.selectedSurvey,
        surveys: state.survey.homePageSurveys,
        messages: state.coursePage.myMessages,
        userType: state.login.identitiy.userType,
        selectedAnnouncement: state.announcement.selectedAnnouncement,
        isSimulate: state.login.identitiy.isSimulate,
        moduleItems: state.login.login.moduleItems
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.profile.userPreferences === prev.profile.userPreferences &&
        next.login.identitiy.loginPermission === prev.login.identitiy.loginPermission &&
        next.announcement.homePageAnnouncements === prev.announcement.homePageAnnouncements &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.survey.homePageSurveys === prev.survey.homePageSurveys &&
        next.survey.selectedSurvey === prev.survey.selectedSurvey &&
        next.coursePage.myMessages === prev.coursePage.myMessages &&
        next.announcement.selectedAnnouncement === prev.announcement.selectedAnnouncement
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const Submain = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual,
    }
)(CSubmain);

export default Submain;
